import _ from 'lodash';
import { SubprojectInfo, TaskPipelineName } from '@scale/shared-types';
import React from 'react';
import { SubprojectInfoBuilderSchema } from '@scale/shared/pipelinev3/sensor-fusion/index';
import { Button } from '@scale/scaleui';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface SubprojectInfoArrayConfigsBuilderProps {
  name: string;
  existingValue?: SubprojectInfo[];
  updateProperty: (arg: Array<SubprojectInfo>) => void;
  required?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const SubprojectInfoArrayConfigsBuilder: React.FC<SubprojectInfoArrayConfigsBuilderProps> = ({
  name,
  existingValue = [],
  updateProperty,
  typeBuilderMap,
}) => {
  const config = existingValue;

  const addConfig = () => {
    const newProjectConfigs = [...existingValue];
    newProjectConfigs.push({
      subprojectKey: '',
      stageDefinitionIds: [],
      v2PipelineName: TaskPipelineName.StandardTask,
    });
    updateProperty(newProjectConfigs);
  };

  return (
    <div className="scaleui scaleui-tailwind scale-theme">
      {name && <div className="my-2 text-lg">{name}</div>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={config}
        setElements={updateProperty}
        getKey={config => JSON.stringify(config)}
        getTitle={config => `${_.capitalize(config.subprojectKey)}`}
        getSchema={() => SubprojectInfoBuilderSchema}
        fullWidth
      />
      <Button onClick={() => addConfig()}>Add {name} Config</Button>
    </div>
  );
};

export default SubprojectInfoArrayConfigsBuilder;
